<template>
  <div id="app">
    <div id="content">
      <transition name="el-zoom-in-center">
       <router-view :key="key"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {

    }
  },
  computed: {
    key() {
      return this.$route.path + Math.random();
    }
  } 
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

#content {
  max-width: 1900px;
  min-width: 1400px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue